/**
 * Normalize a display string or API name to a translation-key slug:
 * lowercase, non-alphanumeric runs collapsed to `_`, no leading/trailing `_`.
 * "Motor Free End" and "motor_free_end" both give "motor_free_end".
 */
export function slugify(value) {
  return String(value == null ? '' : value)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}
